






















import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { jumpPage } from '@/utils/mUtil'

@Component({ components: { Swiper, SwiperSlide } })
export default class Mslider extends Vue {
  @Prop({ type: Array, default: [] })
  list!: Array<any>

  $refs: any

  swiperOption: any = {
    direction: 'horizontal',
    pagination: {
      el: '.swiper-pagination',
      renderBullet(index: number, className: string) {
        return `<span class="${className} swiper-pagination-bullet-custom"></span>`
      },
    },
  }

  created() {
    if (this.list.length > 1) {
      this.swiperOption.autoplay = {
        delay: 5000,
        disableOnInteraction: false,
      }
      this.swiperOption.loop = true
    }
  }

  clickBanner(index: number) {
    let realIndex: number = 0
    if (this.list.length > 1) {
      realIndex = index - 1
    }
    const item = this.list[realIndex]
    const url = item.landing
    if (!url) return
    jumpPage(url)
  } 

  get swiper() {
    return this.$refs.mySwiper.swiper
  }
}
